module.exports = __webpack_public_path__ + "img/product-sm-5.17710e01.png";